export function num(n, order, max) {
  let m = (n / order).toString()
  const dotIndex = m.indexOf('.')
  if (dotIndex >= max - 1) m = m.substring(0, dotIndex)
  else if (dotIndex > 0) m = m.substring(0, max)
  return m
}

export function shortNumberJa(n) {
  if (n >= 100000000) {
    return num(n, 100000000, 4) + '億'
  }
  if (n >= 10000) {
    return num(n, 10000, 4) + '万'
  }
  return n
}

export function shortNumberEn(n) {
  if (n >= 1000000) {
    return num(n, 1000000, 4) + 'M'
  }
  if (n >= 1000) {
    return num(n, 1000, 4) + 'K'
  }
  return n
}

export function floor(n, order) {
  return Math.floor(n * Math.pow(10, -order)) / Math.pow(10, -order)
}

export function padding(n: number, length: number) {
  return ('0000000000000' + n).slice(-length)
}

export function round(value, base): number {
  return Math.round(value * base) / base
}

